import { createFileRoute } from "@tanstack/react-router";

import { MorrowOrganizationPage } from "../components/workspace/MorrowOrganizationPage";

export type OrganizationSearch = {
  readonly view?: "memory";
};

export const Route = createFileRoute("/organization")({
  validateSearch: (raw: Record<string, unknown>): OrganizationSearch => ({
    ...(raw.view === "memory" ? { view: "memory" } : {}),
  }),
  component: MorrowOrganizationPage,
});
